import { RecurringSale, Sale } from './types';
import api from '../../libs/api';

export const saveSale = async (sale: Sale) => api.put('/Sales', sale);
export const saveRecurringSale = async (recurringSale: RecurringSale) => api.put('/recurring-sales', recurringSale);
export const fetchSaleItems = async (key: string) => {
  return api.get('/sale-items');
};
